import React, { useCallback } from "react";
import { observer } from "mobx-react";

import { useRootAppStore } from "@hooks";

import {
	HeaderMenuToggleButton,
	HeaderSpecialLinks,
	HeaderTop,
} from "../components";
import HeaderFailedLoginsCheckButton from "../components/HeaderFailedLoginsCheckButton";
import HeaderSearch from "../components/search/HeaderSearch";
import HeaderUserBalance from "../components/HeaderUserBalance";
import SearchButton from "../components/search/SearchButton";

import { THEME_SETTINGS } from "@theme-settings";

interface SubPageHeaderProps {
	backButton: () => void;
	title: string;
}

export default observer(function SubPageSearchHeader({
	backButton,
	title,
}: SubPageHeaderProps) {
	const {
		userAuthStore: { isLoggedIn },
		searchStore,
	} = useRootAppStore();

	const handleBackClick = useCallback(() => {
		if (typeof backButton === "function") {
			backButton();
		}
	}, [backButton]);

	return (
		<header className="l--header l__header">
			<div className="header header--page">
				<div className="header__top">
					<HeaderTop />

					<HeaderSpecialLinks />
				</div>

				<div className="header__main header--page__main">
					{!searchStore.isSearchOpen && (
						<>
							<button
								type="button"
								className="header--page__back btn btn--square btn--ghost"
								onClick={handleBackClick}
								aria-label="Go Back"
							>
								<i className="u-icon u-icon--tny u-icon--caret-left u-color--core--snow" />
							</button>

							<div className="header__content">
								<h1 className="header__title">{title}</h1>
							</div>

							<nav className="header__nav">
								{isLoggedIn && (
									<>
										{THEME_SETTINGS.failedLoginReport
											.isEnabled && (
											<HeaderFailedLoginsCheckButton
												isLabelHidden={true}
											/>
										)}
										<HeaderUserBalance />
									</>
								)}

								<div className="header__actions">
									<SearchButton />
									<HeaderMenuToggleButton />
								</div>
							</nav>
						</>
					)}

					<HeaderSearch />
				</div>
			</div>
		</header>
	);
});
